import React, { Component } from 'react';
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import { LoginMenu } from './api-authorization/LoginMenu';
import './NavMenu.css';

export class NavMenu extends Component {
    static displayName = NavMenu.name;

    constructor(props) {
        super(props);

        this.toggleNavbar = this.toggleNavbar.bind(this);
        this.state = {
            collapsed: true
        };
    }

    toggleNavbar() {
        this.setState({
            collapsed: !this.state.collapsed
        });
    }

    render() {
        return (
            // <header>
            //     <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3" light style={{display: "flex", alignItems: "center"}}>
            //         <Container style={{display: "flex", alignItems: "center"}}>
            //             <NavbarBrand tag={Link} to="/"><img src="elvna.webp" width="180px" alt="logo"></img></NavbarBrand>
            //             <NavbarToggler onClick={this.toggleNavbar} className="mr-2" />
            //             <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!this.state.collapsed} navbar>
            //                 {/* <ul className="navbar-nav flex-grow">
            //                     <LoginMenu>
            //                     </LoginMenu>
            //                 </ul> */}
            //             </Collapse>
            //         </Container>
            //     </Navbar>
            // </header>

            
            <Container style={{display: "flex", alignItems: "center", justifyContent: "center", width: "100%"}}>
                <Link to="/"><img src="elvna.webp" width="180px" alt="logo"></img></Link>
            </Container>
        );
    }
}
